import React from "react";

// Minimal, tasteful Indian motifs drawn as line SVGs (currentColor). Used sparingly.

export function LotusMark({ className = "h-5 w-5" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 13c0-3 1.4-5.5 0-8-1.4 2.5 0 5 0 8Z" />
      <path d="M12 13c-1.6-2.1-4-3.1-6.5-3 .6 2.5 3 4.3 6.5 3Z" />
      <path d="M12 13c1.6-2.1 4-3.1 6.5-3-.6 2.5-3 4.3-6.5 3Z" />
      <path d="M4 13c1.1 2.6 4 4.3 8 4.3S18.9 15.6 20 13" />
    </svg>
  );
}

// A slim paisley / mango (ambi) divider used between sections.
export function PaisleyDivider({ className = "my-8" }) {
  return (
    <div className={`flex items-center justify-center gap-3 text-gold ${className}`} aria-hidden="true">
      <span className="h-px w-16 bg-current opacity-30" />
      <svg viewBox="0 0 40 20" className="h-4 w-8" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round">
        <path d="M20 3c-6 0-10 4-10 8 0 3 2 5 5 5 2.5 0 4-1.6 4-3.6 0-1.6-1-2.8-2.4-2.8" />
        <path d="M20 3c6 0 10 4 10 8 0 3-2 5-5 5-2.5 0-4-1.6-4-3.6 0-1.6 1-2.8 2.4-2.8" />
      </svg>
      <span className="h-px w-16 bg-current opacity-30" />
    </div>
  );
}

// Subtle diya (lamp) used as a small accent.
export function Diya({ className = "h-4 w-4" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M4 14c2 2.5 5 3.5 8 3.5s6-1 8-3.5c-2-1-5-1.5-8-1.5s-6 .5-8 1.5Z" />
      <path d="M12 12c0-2 1.5-3 1.5-4.5C13.5 6 12.7 5 12 4c-.7 1-1.5 2-1.5 3.5C10.5 9 12 10 12 12Z" />
    </svg>
  );
}
